import { render, staticRenderFns } from "./ghac2.vue?vue&type=template&id=61fadf45&scoped=true&"
import script from "./ghac2.vue?vue&type=script&lang=js&"
export * from "./ghac2.vue?vue&type=script&lang=js&"
import style0 from "./ghac2.vue?vue&type=style&index=0&id=61fadf45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fadf45",
  null
  
)

export default component.exports